import type { ConnectorMultiAgentConfig } from '../services/unifiedWebSocket';
import type {
  OptimizationPreviewRequest,
  OptimizationPreviewRunnerConfig,
} from '../types/optimizationPreview';

function buildPreviewRunnerConfig(
  config: ConnectorMultiAgentConfig['config']
): OptimizationPreviewRunnerConfig {
  const {
    coordinator,
    workers,
    async_orchestrator,
    metaPrompts,
    iterations,
    reminder_prompt_position,
  } = config;

  const runnerConfig: OptimizationPreviewRunnerConfig = {
    coordinator,
    workers,
    iterations: iterations != null && iterations >= 1 ? iterations : 1,
  };

  if (async_orchestrator) {
    runnerConfig.async_orchestrator = async_orchestrator;
  }
  if (metaPrompts) {
    runnerConfig.metaPrompts = metaPrompts;
  }
  if (reminder_prompt_position) {
    runnerConfig.reminder_prompt_position = reminder_prompt_position;
  }

  return runnerConfig;
}

export function buildOptimizationPreviewRequest(
  payload: ConnectorMultiAgentConfig
): OptimizationPreviewRequest {
  const { config, integration_id, approach, optimization_policy } = payload;

  return {
    data: {
      config: buildPreviewRunnerConfig(config),
      dataset_name: config.dataset_name,
      approach: (approach || config.approach || 'BASELINE') as OptimizationPreviewRequest['data']['approach'],
      ...(integration_id ? { integration_id } : {}),
      ...(optimization_policy ? { optimization_policy } : {}),
    },
  };
}
